<template>
  <div class="app-wrapper d-block">
    <main class="w-100 p-0">
      <div class="container-fluid p-0">
        <div class="row g-0 min-vh-100">
          <!-- Left Panel — Brand -->
          <div class="col-lg-5 d-none d-lg-flex align-items-center justify-content-center position-relative"
               style="background: linear-gradient(135deg, #164e63 0%, #155e75 50%, #0e7490 100%);">
            <div class="position-absolute top-0 start-0 w-100 h-100" style="background: url('data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><defs><linearGradient id=%22g%22 x1=%220%25%22 y1=%220%25%22 x2=%22100%25%22 y2=%22100%25%22><stop offset=%220%25%22 stop-color=%22%230891b2%22 stop-opacity=%220.08%22/><stop offset=%22100%25%22 stop-color=%22%2306b6d4%22 stop-opacity=%220.04%22/></linearGradient></defs><rect fill=%22url(%23g)%22 width=%22100%22 height=%22100%22/></svg>'); background-size: cover;"></div>
            <div class="text-center position-relative z-1 px-5">
              <div class="mb-4">
                <img src="/assets/images/logo/shc-logo.png" width="200" alt="Sheria Housing" class="mb-4" style="filter: brightness(0) invert(1); opacity: 0.9;">
              </div>
              <h2 class="text-white fw-bold mb-3" style="letter-spacing: -0.5px;">Member Portal</h2>
              <p class="text-white-50 mb-4 mx-auto" style="max-width: 320px; line-height: 1.7;">
                Access your accounts, track contributions, manage investments, and grow with the cooperative.
              </p>
              <div class="d-flex justify-content-center gap-4 mt-5">
                <div class="text-center">
                  <div class="rounded-3 d-flex align-items-center justify-content-center mx-auto mb-2"
                       style="width: 48px; height: 48px; background: rgba(193,242,249,0.2);">
                    <i class="ph-duotone ph-shield-check text-white f-s-22"></i>
                  </div>
                  <small class="text-white-50">Secure</small>
                </div>
                <div class="text-center">
                  <div class="rounded-3 d-flex align-items-center justify-content-center mx-auto mb-2"
                       style="width: 48px; height: 48px; background: rgba(193,242,249,0.2);">
                    <i class="ph-duotone ph-chart-line-up text-white f-s-22"></i>
                  </div>
                  <small class="text-white-50">Grow</small>
                </div>
                <div class="text-center">
                  <div class="rounded-3 d-flex align-items-center justify-content-center mx-auto mb-2"
                       style="width: 48px; height: 48px; background: rgba(193,242,249,0.2);">
                    <i class="ph-duotone ph-handshake text-white f-s-22"></i>
                  </div>
                  <small class="text-white-50">Together</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Panel — Login Form -->
          <div class="col-lg-7 col-12 d-flex align-items-center justify-content-center" style="background: #f8fafc;">
            <div class="w-100" style="max-width: 440px; padding: 2rem;">
              <!-- Mobile logo -->
              <div class="d-lg-none text-center mb-4">
                <img src="/assets/images/logo/shc-logo.png" width="180" alt="Sheria Housing">
              </div>

              <div class="mb-4">
                <h3 class="fw-bold mb-1" style="color: #0f172a; letter-spacing: -0.3px;">Welcome back</h3>
                <p class="text-muted mb-0">Sign in to access your member dashboard</p>
              </div>

              <!-- Error Alert -->
              <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center border-0 mb-3" role="alert"
                   style="background: #fef2f2; border-radius: 12px;">
                <i class="ph-duotone ph-warning-circle f-s-20 me-2 text-danger"></i>
                <span>{{ errorMessage }}</span>
              </div>

              <form @submit.prevent="loginUser">
                <div class="mb-3">
                  <label class="form-label fw-semibold text-dark f-s-13">National ID or Member Number</label>
                  <div class="position-relative">
                    <i class="ph-duotone ph-identification-card position-absolute f-s-18 text-muted" 
                       style="left: 14px; top: 50%; transform: translateY(-50%);"></i>
                    <input v-model="identifier" type="text" class="form-control form-control-lg" 
                           placeholder="e.g. 12345678 or SHC0001" required
                           style="padding-left: 42px; border-radius: 12px; border-color: #e2e8f0; background: #fff; font-size: 15px;"
                           @keydown.enter="loginUser">
                  </div>
                </div>

                <div class="mb-4">
                  <label class="form-label fw-semibold text-dark f-s-13">Password</label>
                  <div class="position-relative">
                    <i class="ph-duotone ph-lock-simple position-absolute f-s-18 text-muted" 
                       style="left: 14px; top: 50%; transform: translateY(-50%);"></i>
                    <input v-model="password" :type="showPassword ? 'text' : 'password'" class="form-control form-control-lg" 
                           placeholder="Enter your password" required
                           style="padding-left: 42px; padding-right: 42px; border-radius: 12px; border-color: #e2e8f0; background: #fff; font-size: 15px;"
                           @keydown.enter="loginUser">
                    <button type="button" class="btn btn-link position-absolute text-muted p-0 border-0" 
                            style="right: 14px; top: 50%; transform: translateY(-50%);"
                            @click="showPassword = !showPassword">
                      <i :class="showPassword ? 'ph-duotone ph-eye-slash' : 'ph-duotone ph-eye'" class="f-s-18"></i>
                    </button>
                  </div>
                </div>

                <button type="submit" class="btn btn-lg w-100 text-white fw-semibold" :disabled="isLoading"
                        style="background: linear-gradient(135deg, #0891b2, #06b6d4); border: none; border-radius: 12px; padding: 14px; font-size: 15px; letter-spacing: 0.3px; box-shadow: 0 4px 15px rgba(8,145,178,0.3);">
                  <span v-if="isLoading">
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                    Signing in...
                  </span>
                  <span v-else>Sign In</span>
                </button>
              </form>

              <div class="text-center mt-4">
                <small class="text-muted">Protected by Sheria Housing Co-operative Society</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import api from '@/services/axios.js';
import { useUserStore } from '@/store';

export default {
  name: 'LoginComponent',
  data() {
    return {
      identifier: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      showPassword: false,
    };
  },
  mounted() {
    const store = useUserStore();
    if (store.isAuthenticated) {
      this.$router.push('/');
    }
  },
  methods: {
    async loginUser() {
      this.errorMessage = '';
      this.isLoading = true;

      try {
        const response = await api.post('/api/login', {
          identifier: this.identifier,
          password: this.password,
        });

        const store = useUserStore();
        store.setAuth(response.data);

        // Force profile update + password change if flag is set
        if (response.data.must_change_password) {
          this.$router.push({ path: '/profile', query: { update: 'required' } });
          return;
        }

        // Check if profile needs updating (temp email or missing details)
        const user = response.data.user;
        const member = user?.member;
        const needsUpdate = !user?.email || 
                            user?.email?.includes('temp_email_') || 
                            user?.email?.includes('@example.com') ||
                            !member?.mobile_phone ||
                            !member?.email ||
                            member?.email?.includes('temp_email_') ||
                            member?.email?.includes('@example.com');

        if (needsUpdate) {
          this.$router.push({ path: '/profile', query: { update: 'required' } });
        } else {
          this.$router.push('/');
        }
      } catch (error) {
        if (error.response) {
          this.errorMessage = error.response.data.message || 'Invalid credentials. Please try again.';
        } else {
          this.errorMessage = 'Unable to connect to the server. Please check your internet connection.';
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>